/**
 * @generated SignedSource<<f970b7623c1712a015596415bc0fcd47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskCopilotMessageRole = "ASSISTANT" | "USER";
export type AskFellowPanelInnerRefreshQuery$variables = {
  conversationId: string;
};
export type AskFellowPanelInnerRefreshQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly messages?: ReadonlyArray<{
      readonly content: string;
      readonly contentForDisplay: string | null;
      readonly contentJson: any | null;
      readonly createdAt: string;
      readonly id: string;
      readonly isResponse: boolean;
      readonly pending: boolean;
      readonly role: AskCopilotMessageRole;
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ChatMessage_message" | "AskFellowPanelInner_ToolUseAndResult_result" | "AskFellowPanelInner_ToolUseAndResult_use" | "AskFellowPanelInner_groupToolUsesWithResponse_message">;
    }>;
    readonly reachedMessageLimit?: boolean;
    readonly suggestedQuestions?: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
    }>;
    readonly title?: string;
  } | null;
};
export type AskFellowPanelInnerRefreshQuery = {
  response: AskFellowPanelInnerRefreshQuery$data;
  variables: AskFellowPanelInnerRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "conversationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentJson",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pending",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponse",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentForDisplay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reachedMessageLimit",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowPanelInnerRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "AskFellowPanelInner_groupToolUsesWithResponse_message",
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v6/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowPanelInner_ToolUseAndResult_use"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowPanelInner_ToolUseAndResult_result"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowPanelInner_ChatMessage_message"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion"
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "type": "AskCopilotConversation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowPanelInnerRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userRating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "type": "AskCopilotConversation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c366c2671097b6477b9958975f56aa8",
    "id": null,
    "metadata": {},
    "name": "AskFellowPanelInnerRefreshQuery",
    "operationKind": "query",
    "text": "query AskFellowPanelInnerRefreshQuery(\n  $conversationId: ID!\n) {\n  node(id: $conversationId) {\n    __typename\n    ... on AskCopilotConversation {\n      id\n      title\n      messages {\n        id\n        role\n        content\n        contentJson\n        pending\n        createdAt\n        isResponse\n        contentForDisplay\n        ...AskFellowPanelInner_groupToolUsesWithResponse_message\n        ...AskFellowPanelInner_ToolUseAndResult_use\n        ...AskFellowPanelInner_ToolUseAndResult_result\n        ...AskFellowPanelInner_ChatMessage_message\n      }\n      suggestedQuestions {\n        id\n        ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n      }\n      reachedMessageLimit\n    }\n    id\n  }\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  ...AskFellowPanelInner_ToolUseAndResult_use\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_result on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_use on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_groupToolUsesWithResponse_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentForDisplay\n  contentJson\n}\n\nfragment AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n"
  }
};
})();

(node as any).hash = "5eb70b3c3775a62cf323adce3b73d21f";

export default node;
